module.exports = __webpack_public_path__ + "static/media/downArrow.4b632b8b.svg";